import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';

var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(VContainer,[_c(VRow,_vm._l((_vm.workingHoursList),function(workingHours){return _c('WorkingHoursCard',{key:workingHours.workingHoursId,attrs:{"working-hours":workingHours},on:{"delete-working-hours":_vm.removeWorkingHours}})}),1),(_vm.isAdmin)?_c(VRow,[_c('working-hours-card',{on:{"new-working-hours":_vm.addWorkingHours}})],1):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }